import { createContext } from 'react'

export interface DiscardDialogContextValue {
  isFormDirty: (form: string) => boolean
  show: (form?: string, callback?: () => void) => void
  reset: (callback?: () => void) => void
  resetForm: (form: string, callback?: () => void) => void
  onFormChange: (form: string) => void
}

export let DiscardDialogContext = createContext<DiscardDialogContextValue | null>(null)
